import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { withTranslation } from 'react-i18next';
import TopDrugs from '../TopDrugs/index.jsx';
import RxCardSendCoupon from '../RxCard/RxCardSendCoupon';
import Scrollbar from 'react-scrollbars-custom';
import {
  RX_CARD_VIEW,
  PRESC_DESC_URL,
  PRESC_DESC_URL_ES,
  RXSENSE,
  NAVITUS,
  INTELLIMIZE_COUPON_EVENT
} from '../../constants/defaults';
import { newFetchCouponData } from '../../services/Api/Coupon/CouponService';
import DiscountSavingsSection from './DiscountSavingSection';
import PharmacyList from '../common/PharmacyList';
import { getMainStoreLdJson } from './ldJosn';
import Image from '../common/Image.jsx';
import Breadcrumb from '../DrugDetails/Breadcrumb';
import PrescriptionDiscountSearch from './PrescritptionCardSearch';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import SkipTo from '../common/Tag/SkipTo';
import PhysicalCardFormModal from './PhysicalCardFormModal';
import RequestReceiveModal from './RequestReceiveModal';
import AppsPromoHome from '../AppsPromoHome';
import Dialog from '../common/Dialog';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const { API } = require('../../config/' + process.env.REACT_APP_ENV);

function DiscountPage(props) {
  const closeButtonRef = useRef(null);
  const mobileModalRef = useRef(null);
  const skipToEndLinkRef = useRef(null);

  const { staticContext, t, i18n } = props;
  const [cardImage, setCardImage] = useState(null);
  const [selectedPharmacy, setSelectedPharmacy] = useState({
    PartnerUser: '',
    PartnerPassword: '',
    PharmacyName: ''
  });
  const [showMobileModal, setShowMobileModal] = useState(false);
  const [ismobileDisplaySent, setIsmobileDisplaySent] = useState(false);
  const [showPhysicalCardModal, setShowPhysicalCardModal] = useState(false);
  const [internalPharmacy, setInternalPharmacy] = useState(false);
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [scrollPos, setScrollPos] = useState(null);
  const [media, setMedia] = useState();
  const location = useLocation();
  const isBrowser = typeof window !== 'undefined';
  let data;
  if (isBrowser && typeof __INITIAL_DATA__ !== 'undefined') {
    data = window.__INITIAL_DATA__;
  } else {
    data = staticContext.data;
  }

  useEffect(() => {
    document.body.style.overflow = showMobileModal ? 'hidden' : 'auto';
  }, [showMobileModal]);

  const triggerGTMEvent = (res, internalPharmacy) => {
    if (!_.isEmpty(res)) {
      _.triggerGTMVirtualPageViewEvent({
        event: 'cardGenerated',
        authNumber: res.MemberNumberFull,
        grpNumber: res.GroupNumber,
        bin: res.BIN,
        pcn: res.PCN,
        pbm: internalPharmacy ? RXSENSE : NAVITUS
      });
      _.sendIntellimizeEvent(INTELLIMIZE_COUPON_EVENT.GENERATE_CARD);
    }
  };

  const applySelectedPharmacy = async (item, isFromMobile) => {
    setCardImage(null);
    let pharmacy = {
      PartnerUser: item.partnerId,
      PartnerPassword: item.partnerPassword,
      PharmacyName: item.name
    };
    const utmzCookie = _.getCookie('_utmz_custom');
    const utmzCookies = utmzCookie.split('|');
    const source = utmzCookies[2].split('=')[1] || null,
      medium = utmzCookies[1].split('=')[1] || null,
      cgn = utmzCookies[0].split('=')[1] || null;
    let utmParams = {
      src: source,
      med: medium,
      cgn: cgn
    };
    try {
      const fetchCouponResp = await newFetchCouponData(
        item.partnerId,
        item.partnerPassword,
        RX_CARD_VIEW,
        utmParams
      );
      setCardImage(fetchCouponResp.PDFUrl);
      // set urlCardType ?? TODO - Unused variable. Check impact
      setSelectedPharmacy(pharmacy);
      setShowMobileModal(isFromMobile ? true : false);
      setInternalPharmacy(item.internalPharmacy);

      if (isFromMobile) {
        mobileModalRef.current.focus();
      }
      await triggerGTMEvent(fetchCouponResp, item.internalPharmacy);
    } catch (err) {
      console.log(err.message);
    }
  };

  const applyIsmobileDisplaySent = (showMedia, value) => {
    setIsmobileDisplaySent(showMedia);
    setMedia(value === 'Email' ? 'email_label' : 'text_label');
    /**
     * added if value check to because applyIsMobileDisplayEvent is called
     * twice (one immediatly to show sent card and other after 5 sec to hide the sent popup)
     * on send button click.
     * before the second event, if the user opens the discount card model then the model will be closed
     *  when executing setShowMobileModel(false)
     * So added a check for value when sent popup showed then only closing the mobilemodel
     *
     */
    if (value) {
      setShowMobileModal(false);
    }
    setTimeout(() => {
      setIsmobileDisplaySent(false);
    }, 5000);
  };

  const closeModal = () => {
    setShowPhysicalCardModal(false);
    document.body.style.position = 'unset';
    window.scrollTo({ top: scrollPos, behavior: 'instant' });
  };

  const openModal = () => {
    const scrollY = document.documentElement.scrollTop;
    setShowPhysicalCardModal(true);
    setScrollPos(scrollY);
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = `-${parseInt(scrollY + 68)}px`;
  };

  const closeRequestModal = () => {
    setShowRequestModal(false);
  };
  const openRequestModal = () => {
    setShowRequestModal(true);
  };

  const triggerGTMEvents = (event, data) => {
    _.triggerGTMVirtualPageViewEvent({
      event: event,
      pharmacyName: selectedPharmacy.PharmacyName,
      pbm: internalPharmacy ? RXSENSE : NAVITUS,
      ...data
    });
  };

  const setFocusToCloseButton = event => {
    if (!_.isEmpty(event.relatedTarget)) {
      let relatedClassName = event.relatedTarget.className;
      if (relatedClassName.includes('mobileDialog')) {
        return;
      } else {
        closeButtonRef.current.focus();
      }
    }
  };

  let isEs = _.isEqual(i18n.language, 'es');
  // change this sort to pharmacy name.
  let filteredPharmacy = _.sortBy(data?.searchPharmacies, 'name');
  filteredPharmacy = _.filter(filteredPharmacy, pharmacy => {
    if (
      (API.ALLOW_NAVITUS && !pharmacy.internalPharmacy) ||
      pharmacy.internalPharmacy
    ) {
      return pharmacy;
    }
  });
  //to check if device is android. for issue SCDTC-9605
  const isAndroid = isBrowser && /(android)/i.test(window.navigator.userAgent);
  const skipToEndLink = isBrowser && document.getElementById('skipToEndLink');
  const discountCardSection =
    isBrowser && document.getElementById('get-discount-card');

  const handleSkipToEndLink = () => {
    skipToEndLink?.classList.remove('visually-visible');
    skipToEndLink?.setAttribute('tabindex', '-1');
  };

  const handleSkipLinkKeyDown = e => {
    if (e.key === 'Enter') {
      handleSkipToEndLink();
      discountCardSection?.focus();
    } else if (e.key === 'Tab') {
      if (e.shiftKey) {
        isBrowser && document.getElementById('searchPharmacy1').focus();
        handleSkipToEndLink();
      } else {
        isBrowser && document.getElementById('searchPharmacy0').focus();
      }
    }
  };

  const handlePharmacyKeyDown = e => {
    if (e.key === 'Tab') {
      e.preventDefault();
      if (e.shiftKey) {
        handleSkipToEndLink();
        isBrowser &&
          document
            .querySelector('input[placeholder="Search pharmacies"]')
            .focus();
      } else {
        skipToEndLink?.classList.add('visually-visible');
        skipToEndLink?.setAttribute('tabindex', '0');
        skipToEndLinkRef && skipToEndLinkRef?.current?.focus();
      }
    }
  };

  return (
    <main>
      <div className="homepage-new newDiscountPage">
        <Helmet>
          <title>{data && data.metaTitle}</title>
          <meta name="description" content={data && data.metaDescription} />
          <script type="application/ld+json">{getMainStoreLdJson()}</script>
          <link
            rel="canonical"
            href={`https://www.singlecare.com${location.pathname}`}
          />
          <link rel="alternate" href={PRESC_DESC_URL} hrefLang="en-us" />
          <link rel="alternate" href={PRESC_DESC_URL_ES} hrefLang="es-us" />
          <meta property="og:title" content={data && data.ogTitle} />
          <meta
            property="og:description"
            content={data && data.ogDescription}
          />
          <meta
            property="og:url"
            content={`https://www.singlecare.com${location.pathname}`}
          />
          <meta property="og:site_name" content="SingleCare" />
          <meta property="og:type" content="website" />
          <meta
            property="og:image"
            content={
              'https://www.singlecare.com/content/images/homepage/singleCareLogo.jpg'
            }
          />
        </Helmet>
        {showPhysicalCardModal && (
          <PhysicalCardFormModal
            t={t}
            closeModal={closeModal}
            triggerGTMEvents={triggerGTMEvents}
            selectedPharmacy={selectedPharmacy}
            openRequestModal={openRequestModal}
          />
        )}
        {showRequestModal && (
          <RequestReceiveModal
            t={t}
            language={i18n && i18n.language}
            closeRequestModal={closeRequestModal}
            triggerGTMEvents={triggerGTMEvents}
            selectedPrice={selectedPharmacy}
            showRequestModal={showRequestModal}
          />
        )}
        <div className="DiscountPageContainer">
          <div className="LandingSearch">
            <Breadcrumb>
              <span>
                <a href={_.withLocale(i18n.language, '/')}>{t(`Home`)}</a>
              </span>
              {!isEs ? (
                <span>{`${t('Prescription Discount Card')}`}</span>
              ) : (
                <span>{`${t(
                  'Prescription Discount Card'
                )} en SingleCare pharmacy`}</span>
              )}
            </Breadcrumb>
          </div>
          <div className="DiscountPageContent">
            <SkipTo>
              <h1>{data && data.h1}</h1>
            </SkipTo>
            <h2>{data && data.h2}</h2>
            <div
              className={`cardMainSection ${
                API.ALLOW_PHYSICAL_CARD ? 'addedPhysicalCardButton' : ' '
              }`}
            >
              <div
                className="searchPharmacySection"
                aria-labelledby="search-your-pharmacy"
                role="search"
              >
                <h2
                  id="search-your-pharmacy"
                  className="textCenter searchHeading"
                >
                  {t('Search your pharmacy')}
                </h2>
                <PrescriptionDiscountSearch
                  searchPharmacies={filteredPharmacy}
                  pharmacyName={selectedPharmacy.PharmacyName}
                  setSelectedPharmacy={applySelectedPharmacy}
                />
                <h3>{t('or select a pharmacy below')}</h3>
                <a
                  ref={skipToEndLinkRef}
                  tabIndex="-1"
                  id="skipToEndLink"
                  href={`#${t('ID CONTENT')}`}
                  className="visually-hidden themeFocus"
                  onClick={e => {
                    e.preventDefault();
                    handleSkipToEndLink();
                    discountCardSection?.focus();
                  }}
                  onKeyDown={handleSkipLinkKeyDown}
                >
                  {t('or skip to end')}
                </a>

                <Scrollbar
                  className="desktop-only"
                  style={{ width: 368, height: 280 }}
                >
                  <ul className="searchPharmacyList">
                    {filteredPharmacy &&
                      _.map(filteredPharmacy, (item, key) => {
                        return (
                          <li key={key}>
                            <button
                              id={`searchPharmacy${key}`}
                              role="button"
                              onKeyDown={e => {
                                if (e.key === 'Enter')
                                  applySelectedPharmacy(item, false);
                                else key === 0 && handlePharmacyKeyDown(e);
                              }}
                              onClick={() => {
                                applySelectedPharmacy(item, false);
                                handleSkipToEndLink();
                              }}
                              aria-haspopup="false"
                              aria-expanded="false"
                              className={`lists themeFocus ${
                                item.name === selectedPharmacy.PharmacyName &&
                                'activeList'
                              }`}
                            >
                              <LazyLoadImage
                                alt={item.logoAltTextForPharmacy}
                                src={item.logo}
                                height="auto"
                                width="74px"
                              />
                            </button>
                          </li>
                        );
                      })}
                  </ul>
                </Scrollbar>

                <Scrollbar
                  className="centerDiv mobile-only"
                  style={{ width: 236, height: 375 }}
                >
                  {isBrowser && (
                    <ul className="searchPharmacyList">
                      {filteredPharmacy &&
                        _.map(filteredPharmacy, (item, key) => {
                          return (
                            <li
                              className={`lists themeFocus ${
                                item.name === selectedPharmacy.PharmacyName &&
                                'activeList'
                              }`}
                              onClick={() => applySelectedPharmacy(item, true)}
                              onKeyDown={e => {
                                if (e.key === 'Enter') {
                                  applySelectedPharmacy(item, true);
                                }
                              }}
                              key={key}
                              tabIndex="0"
                            >
                              {isAndroid ? (
                                <span>{item.name}</span>
                              ) : (
                                <LazyLoadImage
                                  alt={item.logoAltTextForPharmacy}
                                  src={item.logo}
                                />
                              )}
                            </li>
                          );
                        })}
                    </ul>
                  )}
                </Scrollbar>
                <div className="separatorLine"></div>
              </div>
              <div
                id="get-discount-card"
                className="CardMasheadDetails desktop-only"
                tabIndex="-1"
              >
                <h2 className="textCenter searchHeading">
                  {t('Get discount card')}
                </h2>
                {cardImage ? (
                  <div>
                    <div className="card-masthead--image ">
                      <Image
                        imageUrl={cardImage}
                        imageAlt={
                          isEs
                            ? t('discount-card') + selectedPharmacy.PharmacyName
                            : selectedPharmacy.PharmacyName + t('discount-card')
                        }
                        imageClass="contactImage"
                        containerClass="imageContainer"
                        loaderClass="loaderImage"
                        loaderalt={t('Prescription card loading prescription')}
                        role="progressbar"
                        areaLive={true}
                      />
                    </div>
                    <p className="textCenter pharmacyNote">
                      {t('Make sure you show this card to your pharmacist')}{' '}
                      <br />
                      {t('at')}&nbsp;
                      <span>{selectedPharmacy.PharmacyName}</span>
                    </p>
                    <RxCardSendCoupon
                      selectedPrice={selectedPharmacy}
                      isRxCard={true}
                      isFromDiscountPage={true}
                      isFromPhysicalModal={false}
                      buttonLocation={'prescription-discount-card'}
                      openModal={openModal}
                      triggerGTMEvents={triggerGTMEvents}
                    />
                  </div>
                ) : (
                  <div className="deactivatedCard">
                    <div className="CardMasheadDetails">
                      <div className="card-masthead--image">
                        <LazyLoadImage
                          className="contactImage"
                          src="/content/images/bg/deactivatedCard.svg"
                          alt=""
                          width="351"
                          height="223"
                        />
                        <div className="cardContent">
                          <LazyLoadImage
                            src="/content/images/bg/singlecare-logo-grey.svg"
                            alt=""
                            height="26"
                            width="139"
                          />
                          <p>{t('card_text')}</p>
                        </div>
                      </div>
                      <div className="send-section">
                        <div className="send-button-section">
                          <div className="btn-wrapper">
                            <div className="btn-padding">
                              <button
                                className="email-button email-send email-button-padding active themeFocus"
                                aria-disabled="true"
                                tabIndex={-1}
                              >
                                {t('Email')}
                              </button>
                            </div>
                            <div className="btn-padding">
                              <button
                                className="text-button text-send text-button-padding active themeFocus"
                                aria-disabled="true"
                                tabIndex={-1}
                              >
                                {t('Text')}
                              </button>
                            </div>
                            <button
                              className="physicalCardDisable themeFocus"
                              aria-disabled="true"
                              tabIndex={-1}
                            >
                              {t('Get physical card')}
                            </button>
                            <div className="btn-padding pdf-button">
                              <button
                                className="pdf-button pdf-send print-button-padding active themeFocus"
                                aria-disabled="true"
                                tabIndex={-1}
                              >
                                <span className="pdf-button">Print</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {showMobileModal && (
                <div className="mobile-only">
                  <div
                    tabIndex="0"
                    className="mainModal rcCardModal"
                    ref={mobileModalRef}
                  >
                    <div
                      className="transparentBg"
                      onClick={() => setShowMobileModal(false)}
                    ></div>

                    <Dialog
                      className="modalContent"
                      onBlur={setFocusToCloseButton}
                      escKeyFunction={() => setShowMobileModal(false)}
                    >
                      <div className="closeModal">
                        <button
                          className="closeModalButton dialogComponent mobileDialog whiteFocus"
                          tabIndex="0"
                          ref={closeButtonRef}
                          onClick={() => setShowMobileModal(false)}
                          aria-label={t('Close')}
                        >
                          <LazyLoadImage
                            src="/content/images/icons/close.svg"
                            alt=""
                            aria-hidden="true"
                            role="button"
                          />
                        </button>
                      </div>
                      <div>
                        <div className="CardMasheadDetails">
                          <h2
                            className="textCenter searchHeading"
                            id="dialogTitleHeading"
                          >
                            {t('Get discount card')}
                          </h2>
                          <div className="card-masthead--image ">
                            <Image
                              imageUrl={cardImage}
                              imageAlt={
                                isEs
                                  ? t('discount-card') +
                                    selectedPharmacy.PharmacyName
                                  : selectedPharmacy.PharmacyName +
                                    t('discount-card')
                              }
                              imageClass="contactImage"
                              containerClass="imageContainer"
                              loaderClass="loaderImage"
                              loaderalt={t('Prescription card loading')}
                            />
                          </div>
                          <p className="textCenter pharmacyNote">
                            {t(
                              'Make sure you show this card to your pharmacist'
                            )}
                            &nbsp;{t('at')}&nbsp;
                            <span>{selectedPharmacy.PharmacyName}</span>
                          </p>
                          <RxCardSendCoupon
                            selectedPrice={selectedPharmacy}
                            isRxCard={true}
                            setIsmobileDisplaySent={applyIsmobileDisplaySent}
                            openModal={openModal}
                            triggerGTMEvents={triggerGTMEvents}
                            closeMobileButtonModal={() =>
                              setShowMobileModal(false)
                            }
                          />
                        </div>
                      </div>
                    </Dialog>
                  </div>
                </div>
              )}
              {ismobileDisplaySent && (
                <div className="messageSendModal">
                  {i18n.language === 'en' ? (
                    <p>
                      {t('Sent! Check your')}&nbsp;
                      <span>{t(media)}</span>&nbsp;
                      {t('for your card')}
                    </p>
                  ) : (
                    <p>
                      {t('Sent! Look for your card in your')}&nbsp;
                      <span>{t(media)}.</span>
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="cardDescription">
            {data && data.cardHighlights && (
              <div className="card-masthead-description">
                {documentToReactComponents(JSON.parse(data.cardHighlights))}
              </div>
            )}
          </div>
          <div className="topDrugsSection">
            <h2 className="subTitle">
              {data && data.popularPrescriptionsSubhead}
            </h2>
            <TopDrugs
              drugsObj={{
                drugs: data?.popularPrescriptions?.drugs
              }}
            />
            <div>
              <AppsPromoHome
                QRImage={'/content/images/homepagev2/hz9nm4kx_qr_code.svg'}
                appStoreLink={'https://singlecare.onelink.me/OxIQ/wda9nocc'}
                playStoreLink={'https://singlecare.onelink.me/OxIQ/8zyppn7x'}
                altText={t('QR code to download the app')}
              />
              <section className="drug-faqs">
                <div className="faq-list">
                  <h2>{data && data.faqSubhead}</h2>
                  <div className="faq-art">
                    <div className="faq-art-b">
                      {data &&
                        data.faQs &&
                        documentToReactComponents(JSON.parse(data.faQs))}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <DiscountSavingsSection
            isSinglecare={true}
            pharmacyName={selectedPharmacy.PharmacyName}
          />
          <div className="unlockPrescriptionContainer">
            <h2>{data && data.cardSelectorSubhead}</h2>
            <PharmacyList
              isSinglecare={true}
              cardSelectorPharmacies={data && data.cardSelectorPharmacies}
            />
          </div>
        </div>
      </div>
    </main>
  );
}

export default withTranslation()(DiscountPage);
